import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { useNavigate } from "react-router-dom";
export function BackBtn() {
    const navigate = useNavigate();
    return (
        <ArrowLeftIcon className="w-6 h-6 text-theme-text dark:text-dark-text sm:hidden m-2" onClick={() => navigate(-1)}/>
    );
}
